/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component } from 'react';
import store from 'features/store';
import { Form, Button, Col, Table } from 'react-bootstrap';
import { MyAccountMenuList } from '../MyAccountMenuList';
import { connect } from 'react-redux';
import { CategoryService } from 'shared/services';
import validators from 'shared/validators';

import './Listing.scss';

/**


@Author Karthik

@param

@return html code for listing

**/

class Listing extends Component {
    constructor(props) {
        super(props);
        this.listingForm = {
            category: { value: '', error: '', validators: [validators.required()] },
            keyword: { value: '', error: '', validators: [validators.required()] },
            zipcode: { value: '', error: '', validators: [validators.required()] },
            miles: { value: '', error: '', validators: [validators.required()] }
        }
        this.state = {
            pageLoading: false,
            categoryList: [],
            listingList: [],
            listingForm: Object.assign({}, this.listingForm),
            formValid: false
        }
    }

    componentDidMount() {
        store.dispatch({ type: 'SIDEBAR_MENU_LIST', payload: { menuList: MyAccountMenuList(), withSpan: false } });
        store.dispatch({ type: 'SET_SIDEBAR', payload: true });
        this.getCategoryList();
    }

    getCategoryList = () => {
        CategoryService.getCategoryList().then(
            res => {
                this.setState({
                    categoryList: res.data.data
                });
            }
        ).catch(error => error);
    }

    /* checks whether the input is valid or not */
    onInputValidation = (event, formName) => {
        let controlError = '';

        /* checks all the validators for the control */
        for (let validator of this.state[formName][event.target.name].validators) {
            controlError = validator(event.target.value);
            if (controlError) break;
        }

        /* sets the state of the control and form validity */
        this.setState({
            [formName]: {
                ...this.state[formName],
                [event.target.name]: {
                    ...this.state[formName][event.target.name],
                    value: event.target.value,
                    valid: !Boolean(controlError),
                    error: controlError
                }
            }
        },
            () => {
                /* check form validity */
                if (controlError)
                    this.setState({ formValid: false });
                else {
                    let formValid = true;
                    for (let control of Object.keys(this.state[formName])) {
                        if (!this.state[formName][control].valid) {
                            formValid = false;
                            break;
                        }
                    }
                    this.setState({ formValid: formValid });
                }
            });
    }

    remove = (index) => {
        const temp = this.state.listingList;
        temp.splice(index, 1)
        this.setState({
            listingList: temp
        });
    }

    submit = () => {
        const listingForm = {
            category: this.state.listingForm.category.value,
            keyword: this.state.listingForm.keyword.value,
            zipcode: this.state.listingForm.zipcode.value,
            miles: this.state.listingForm.miles.value
        }

        const temp = this.state.listingList.concat([listingForm]);
        this.setState({
            listingList: temp,
            listingForm: Object.assign({}, this.listingForm),
            formValid: false
        });
    }

    componentWillUnmount() {
        store.dispatch({ type: 'SET_SIDEBAR', payload: false });
    }

    render() {
        return (
            <div className="listing-main top-border">
                {
                    this.state.pageLoading ?
                        <div className="loader d-flex align-items-center justify-content-center">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                        </div> :
                        <div className="main-content">
                            <div className="top-header">
                                CTBids will send you an email of all the listings started in the categories selected
                            </div>
                            <div className="form-container">
                                <Form>
                                    <div className="row-handle d-lg-flex align-items-center">
                                        <div className="col-handle">
                                            <Form.Group as={Col} controlId="category">
                                                <Form.Label>Select By Categories*</Form.Label>
                                                <Form.Control as="select" size="lg" className={`${this.state.listingForm.category.value ? '' : 'normal-text'}`} name="category" value={this.state.listingForm.category.value} onChange={(event) => this.onInputValidation(event, 'listingForm')}>
                                                    <option style={{ display: "none" }} >Select category</option>
                                                    {
                                                        this.state.categoryList.map(category => <option>{category.category}</option>)
                                                    }

                                                </Form.Control>
                                            </Form.Group>
                                        </div>
                                        <div className="col-handle">
                                            <Form.Group as={Col} controlId="keyword">
                                                <Form.Label>Key Words</Form.Label>
                                                <Form.Control size="lg" name="keyword" value={this.state.listingForm.keyword.value} onChange={(event) => this.onInputValidation(event, 'listingForm')} />
                                            </Form.Group>
                                        </div>
                                        <div className="col-handle">
                                            <Form.Group as={Col} controlId="zipcode">
                                                <Form.Label>Zip Code</Form.Label>
                                                <Form.Control size="lg" name="zipcode" value={this.state.listingForm.zipcode.value} onChange={(event) => this.onInputValidation(event, 'listingForm')} />
                                            </Form.Group>
                                        </div>
                                        <div className="col-handle">
                                            <Form.Group as={Col} controlId="miles">
                                                <Form.Label>Miles</Form.Label>
                                                <Form.Control as="select" size="lg" className={`${this.state.listingForm.miles.value ? '' : 'normal-text'}`} value={this.state.listingForm.miles.value} name="miles" onChange={(event) => this.onInputValidation(event, 'listingForm')}>
                                                    <option style={{ display: "none" }}>Select mile</option>
                                                    <option>5</option>
                                                    <option>10</option>
                                                    <option>15</option>
                                                    <option>20</option>
                                                    <option>30</option>
                                                    <option>40</option>
                                                    <option>50</option>
                                                </Form.Control>
                                            </Form.Group>
                                        </div>
                                        <div className="col-handle-button">
                                            <div className="buttons w-100 h-100 d-flex align-items-center">
                                                <Button variant="secondary" size="lg" disabled={!this.state.formValid} onClick={this.submit}>Add</Button>
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                            <div className="list-container">
                                <Table>
                                    <thead>
                                        <tr>
                                            <th>Categories</th>
                                            <th>Keywords</th>
                                            <th>Zipcode</th>
                                            <th>Miles</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.listingList.map((listing, index) =>
                                                <tr>
                                                    <td>{listing.category}</td>
                                                    <td>{listing.keyword}</td>
                                                    <td>{listing.zipcode}</td>
                                                    <td>{listing.miles}</td>
                                                    <td className="d-flex align-items-center justify-content-center table-action">
                                                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/close.svg`} alt="close-icon" className="clickable" onClick={() => this.remove(index)}></img>
                                                    </td>
                                                </tr>

                                            )
                                        }

                                    </tbody>
                                </Table>
                            </div>
                        </div>
                }
            </div>
        );
    }
}

export default connect(state => state)(Listing);